import type {
  TeamDto,
  TeamMatchDetailDto,
  TipDetailDto,
} from '@/api/backoffice-schemas';

export function getExpectedWinner({
  tip,
}: {
  tip: TipDetailDto;
}): TeamDto | null {
  const { match, team } = tip;

  if (!match) {
    return null;
  }

  if (!team) {
    return null;
  }

  const { teamMatches } = match;

  if (!teamMatches) {
    return null;
  }

  return (
    teamMatches.find(
      (teamMatch) => teamMatch.team?.externalId === team.externalId
    )?.team ?? null
  );
}

export function getTipPageTitle(tip: TipDetailDto): string {
  const teams = tip.match?.teamMatches ?? [];

  return tip.title ?? `${getTeamName(teams[0])} vs ${getTeamName(teams[1])}`;
}

function getTeamName(team: TeamMatchDetailDto | undefined): string {
  if (!team?.team?.name) {
    return 'TBD';
  }

  return team.team.name;
}
